// axios
import axios from 'axios'

const domain = "";

let instance = axios.create({
  domain,
})

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // config.domain = domain;
  // config.headers['Access-Control-Allow-Origin'] =  '*';
  config.headers['authorization'] =  localStorage.getItem('token');

  return config;
});

export default instance

